import { useState, useEffect } from "react";

export default function useOfferStatus(statusId) {
  const [offerStatuses, setOfferStatuses] = useState([]);
  const [currentStatus, setCurrentStatus] = useState({});

  const allStatuses = [
    {
      id: "null",
      name: "New",
      color: "warning.80",
      backgroundColor: "warning.20"
    },
    {
      id: "0",
      name: "Approved",
      color: "success.80",
      backgroundColor: "success.20"
    },
    {
      id: "1",
      name: "Rejected",
      color: "black_solid.80",
      backgroundColor: "black_solid.20"
    },
    {
      id: "2",
      name: "Countered",
      color: "error.80",
      backgroundColor: "error.20"
    },
    {
      id: "3",
      name: "", //Cleared
      color: "black_solid.80",
      backgroundColor: "transparent"
    },
    {
      id: "4",
      name: "New", //Reinstated
      color: "warning.80",
      backgroundColor: "warning.20"
    },
    {
      id: "5",
      name: "Approved", //Booked
      color: "success.80",
      backgroundColor: "success.20"
    },
    {
      id: "6",
      name: "Bounced",
      color: "purple.80",
      backgroundColor: "purple.20"
    },
    {
      id: "7",
      name: "No Capacity",
      color: "magenta.80",
      backgroundColor: "magenta.20"
    },
  ];

  useEffect(() => {
    setOfferStatuses(allStatuses);
  }, []);

  useEffect(() => {
    const index = offerStatuses.findIndex(status => status.id === statusId);
    setCurrentStatus(offerStatuses[index]);
  }, [statusId, offerStatuses]);

  return { offerStatuses, currentStatus };
}